import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IPaymentResponse } from "../../Orchestrator/Types/Index";


export async function getBookingPaymentData(bookingId: string, showLoader?: boolean): Promise<IApiResponse<IPaymentResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.getBookingPaymentData(bookingId)}`;
    return await apiRequest<IPaymentResponse>(endpoint, 'GET', {}, 'none', undefined, undefined, showLoader);
}